import React, { ReactNode } from 'react';
import classNames from 'classnames';
import { Button } from './Button';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import './squareButton.module.scss';
import { EnhancedLocationDescriptor } from '../../../../mainv3/routes/index';

type ButtonProps = {
  id: string;
  type?: 'primary' | 'multicreator';
  loading: boolean;
  label: ReactNode;
  buttonWidth?: string;
  onReservationClick?: () => void;
  href?: string | EnhancedLocationDescriptor;
  target?: string;
};

export const SquareButton = ({
  id,
  loading,
  type = 'primary',
  onReservationClick,
  label,
  buttonWidth = 'auto',
  href,
  target,
}: ButtonProps) => {
  return (
    <div styleName={classNames('square-button', type)} style={{ width: buttonWidth }}>
      <Button
        id={id}
        type={type}
        size="l"
        loading={loading}
        onClick={onReservationClick}
        fullWidth={true}
        target={target}
        href={href}
      >
        {label}
      </Button>
      <ArrowRightIcon style={{ color: '#FFFFFF', fontSize: 28, position: 'absolute', right: '12px' }} />
    </div>
  );
};
